/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TimesheetRouteImport } from './routes/timesheet'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ApprovalsRouteImport } from './routes/approvals'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as WikiRouteRouteImport } from './routes/wiki/route'
import { Route as MessagesRouteRouteImport } from './routes/messages/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WikiIndexRouteImport } from './routes/wiki/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as MessagesIndexRouteImport } from './routes/messages/index'
import { Route as WikiNewRouteImport } from './routes/wiki/new'
import { Route as WikiSlugWithTailRouteImport } from './routes/wiki/$slugWithTail'
import { Route as EventsEventIdRouteImport } from './routes/events/$eventId'
import { Route as BoardProjectIdRouteImport } from './routes/board/$projectId'
import { Route as AnnouncementsAnnouncementIdRouteImport } from './routes/announcements/$announcementId'
import { Route as MessagesConversationIdRouteRouteImport } from './routes/messages/$conversationId/route'
import { Route as MessagesConversationIdIndexRouteImport } from './routes/messages/$conversationId/index'
import { Route as ProjectsProjectIdSettingsRouteImport } from './routes/projects/$projectId/settings'
import { Route as ProjectCodeTicketsShorthandRouteImport } from './routes/$projectCode/tickets/$shorthand'
import { Route as ProjectCodeTasksShorthandRouteImport } from './routes/$projectCode/tasks/$shorthand'
import { Route as WikiDDocIdIndexRouteImport } from './routes/wiki/d/$docId/index'
import { Route as MessagesConversationIdTParentIdRouteImport } from './routes/messages/$conversationId/t/$parentId'
import { Route as WikiDDocIdVersionsIndexRouteImport } from './routes/wiki/d/$docId/versions/index'

const TimesheetRoute = TimesheetRouteImport.update({
  id: '/timesheet',
  path: '/timesheet',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ApprovalsRoute = ApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const WikiRouteRoute = WikiRouteRouteImport.update({
  id: '/wiki',
  path: '/wiki',
  getParentRoute: () => rootRouteImport,
} as any)
const MessagesRouteRoute = MessagesRouteRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WikiIndexRoute = WikiIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WikiRouteRoute,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const MessagesIndexRoute = MessagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MessagesRouteRoute,
} as any)
const WikiNewRoute = WikiNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => WikiRouteRoute,
} as any)
const WikiSlugWithTailRoute = WikiSlugWithTailRouteImport.update({
  id: '/$slugWithTail',
  path: '/$slugWithTail',
  getParentRoute: () => WikiRouteRoute,
} as any)
const EventsEventIdRoute = EventsEventIdRouteImport.update({
  id: '/events/$eventId',
  path: '/events/$eventId',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardProjectIdRoute = BoardProjectIdRouteImport.update({
  id: '/board/$projectId',
  path: '/board/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const AnnouncementsAnnouncementIdRoute =
  AnnouncementsAnnouncementIdRouteImport.update({
    id: '/announcements/$announcementId',
    path: '/announcements/$announcementId',
    getParentRoute: () => rootRouteImport,
  } as any)
const MessagesConversationIdRouteRoute =
  MessagesConversationIdRouteRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => MessagesRouteRoute,
  } as any)
const MessagesConversationIdIndexRoute =
  MessagesConversationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MessagesConversationIdRouteRoute,
  } as any)
const ProjectsProjectIdSettingsRoute =
  ProjectsProjectIdSettingsRouteImport.update({
    id: '/projects/$projectId/settings',
    path: '/projects/$projectId/settings',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectCodeTicketsShorthandRoute =
  ProjectCodeTicketsShorthandRouteImport.update({
    id: '/$projectCode/tickets/$shorthand',
    path: '/$projectCode/tickets/$shorthand',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectCodeTasksShorthandRoute =
  ProjectCodeTasksShorthandRouteImport.update({
    id: '/$projectCode/tasks/$shorthand',
    path: '/$projectCode/tasks/$shorthand',
    getParentRoute: () => rootRouteImport,
  } as any)
const WikiDDocIdIndexRoute = WikiDDocIdIndexRouteImport.update({
  id: '/d/$docId/',
  path: '/d/$docId/',
  getParentRoute: () => WikiRouteRoute,
} as any)
const MessagesConversationIdTParentIdRoute =
  MessagesConversationIdTParentIdRouteImport.update({
    id: '/t/$parentId',
    path: '/t/$parentId',
    getParentRoute: () => MessagesConversationIdRouteRoute,
  } as any)
const WikiDDocIdVersionsIndexRoute = WikiDDocIdVersionsIndexRouteImport.update({
  id: '/d/$docId/versions/',
  path: '/d/$docId/versions/',
  getParentRoute: () => WikiRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/messages': typeof MessagesRouteRouteWithChildren
  '/wiki': typeof WikiRouteRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/approvals': typeof ApprovalsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/reports': typeof ReportsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/timesheet': typeof TimesheetRoute
  '/messages/$conversationId': typeof MessagesConversationIdRouteRouteWithChildren
  '/announcements/$announcementId': typeof AnnouncementsAnnouncementIdRoute
  '/board/$projectId': typeof BoardProjectIdRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/wiki/$slugWithTail': typeof WikiSlugWithTailRoute
  '/wiki/new': typeof WikiNewRoute
  '/messages/': typeof MessagesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/wiki/': typeof WikiIndexRoute
  '/$projectCode/tasks/$shorthand': typeof ProjectCodeTasksShorthandRoute
  '/$projectCode/tickets/$shorthand': typeof ProjectCodeTicketsShorthandRoute
  '/projects/$projectId/settings': typeof ProjectsProjectIdSettingsRoute
  '/messages/$conversationId/': typeof MessagesConversationIdIndexRoute
  '/messages/$conversationId/t/$parentId': typeof MessagesConversationIdTParentIdRoute
  '/wiki/d/$docId/': typeof WikiDDocIdIndexRoute
  '/wiki/d/$docId/versions/': typeof WikiDDocIdVersionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/approvals': typeof ApprovalsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/reports': typeof ReportsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/timesheet': typeof TimesheetRoute
  '/announcements/$announcementId': typeof AnnouncementsAnnouncementIdRoute
  '/board/$projectId': typeof BoardProjectIdRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/wiki/$slugWithTail': typeof WikiSlugWithTailRoute
  '/wiki/new': typeof WikiNewRoute
  '/messages': typeof MessagesIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/wiki': typeof WikiIndexRoute
  '/$projectCode/tasks/$shorthand': typeof ProjectCodeTasksShorthandRoute
  '/$projectCode/tickets/$shorthand': typeof ProjectCodeTicketsShorthandRoute
  '/projects/$projectId/settings': typeof ProjectsProjectIdSettingsRoute
  '/messages/$conversationId': typeof MessagesConversationIdIndexRoute
  '/messages/$conversationId/t/$parentId': typeof MessagesConversationIdTParentIdRoute
  '/wiki/d/$docId': typeof WikiDDocIdIndexRoute
  '/wiki/d/$docId/versions': typeof WikiDDocIdVersionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/messages': typeof MessagesRouteRouteWithChildren
  '/wiki': typeof WikiRouteRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/approvals': typeof ApprovalsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/reports': typeof ReportsRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/timesheet': typeof TimesheetRoute
  '/messages/$conversationId': typeof MessagesConversationIdRouteRouteWithChildren
  '/announcements/$announcementId': typeof AnnouncementsAnnouncementIdRoute
  '/board/$projectId': typeof BoardProjectIdRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/wiki/$slugWithTail': typeof WikiSlugWithTailRoute
  '/wiki/new': typeof WikiNewRoute
  '/messages/': typeof MessagesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/wiki/': typeof WikiIndexRoute
  '/$projectCode/tasks/$shorthand': typeof ProjectCodeTasksShorthandRoute
  '/$projectCode/tickets/$shorthand': typeof ProjectCodeTicketsShorthandRoute
  '/projects/$projectId/settings': typeof ProjectsProjectIdSettingsRoute
  '/messages/$conversationId/': typeof MessagesConversationIdIndexRoute
  '/messages/$conversationId/t/$parentId': typeof MessagesConversationIdTParentIdRoute
  '/wiki/d/$docId/': typeof WikiDDocIdIndexRoute
  '/wiki/d/$docId/versions/': typeof WikiDDocIdVersionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/messages'
    | '/wiki'
    | '/accept-invite'
    | '/approvals'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/reports'
    | '/reset-password'
    | '/signup'
    | '/timesheet'
    | '/messages/$conversationId'
    | '/announcements/$announcementId'
    | '/board/$projectId'
    | '/events/$eventId'
    | '/wiki/$slugWithTail'
    | '/wiki/new'
    | '/messages/'
    | '/settings/'
    | '/wiki/'
    | '/$projectCode/tasks/$shorthand'
    | '/$projectCode/tickets/$shorthand'
    | '/projects/$projectId/settings'
    | '/messages/$conversationId/'
    | '/messages/$conversationId/t/$parentId'
    | '/wiki/d/$docId/'
    | '/wiki/d/$docId/versions/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invite'
    | '/approvals'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/reports'
    | '/reset-password'
    | '/signup'
    | '/timesheet'
    | '/announcements/$announcementId'
    | '/board/$projectId'
    | '/events/$eventId'
    | '/wiki/$slugWithTail'
    | '/wiki/new'
    | '/messages'
    | '/settings'
    | '/wiki'
    | '/$projectCode/tasks/$shorthand'
    | '/$projectCode/tickets/$shorthand'
    | '/projects/$projectId/settings'
    | '/messages/$conversationId'
    | '/messages/$conversationId/t/$parentId'
    | '/wiki/d/$docId'
    | '/wiki/d/$docId/versions'
  id:
    | '__root__'
    | '/'
    | '/messages'
    | '/wiki'
    | '/accept-invite'
    | '/approvals'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/reports'
    | '/reset-password'
    | '/signup'
    | '/timesheet'
    | '/messages/$conversationId'
    | '/announcements/$announcementId'
    | '/board/$projectId'
    | '/events/$eventId'
    | '/wiki/$slugWithTail'
    | '/wiki/new'
    | '/messages/'
    | '/settings/'
    | '/wiki/'
    | '/$projectCode/tasks/$shorthand'
    | '/$projectCode/tickets/$shorthand'
    | '/projects/$projectId/settings'
    | '/messages/$conversationId/'
    | '/messages/$conversationId/t/$parentId'
    | '/wiki/d/$docId/'
    | '/wiki/d/$docId/versions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  MessagesRouteRoute: typeof MessagesRouteRouteWithChildren
  WikiRouteRoute: typeof WikiRouteRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  ApprovalsRoute: typeof ApprovalsRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  ReportsRoute: typeof ReportsRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  TimesheetRoute: typeof TimesheetRoute
  AnnouncementsAnnouncementIdRoute: typeof AnnouncementsAnnouncementIdRoute
  BoardProjectIdRoute: typeof BoardProjectIdRoute
  EventsEventIdRoute: typeof EventsEventIdRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  ProjectCodeTasksShorthandRoute: typeof ProjectCodeTasksShorthandRoute
  ProjectCodeTicketsShorthandRoute: typeof ProjectCodeTicketsShorthandRoute
  ProjectsProjectIdSettingsRoute: typeof ProjectsProjectIdSettingsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/timesheet': {
      id: '/timesheet'
      path: '/timesheet'
      fullPath: '/timesheet'
      preLoaderRoute: typeof TimesheetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/approvals': {
      id: '/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof ApprovalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wiki': {
      id: '/wiki'
      path: '/wiki'
      fullPath: '/wiki'
      preLoaderRoute: typeof WikiRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messages': {
      id: '/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof MessagesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wiki/': {
      id: '/wiki/'
      path: '/'
      fullPath: '/wiki/'
      preLoaderRoute: typeof WikiIndexRouteImport
      parentRoute: typeof WikiRouteRoute
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messages/': {
      id: '/messages/'
      path: '/'
      fullPath: '/messages/'
      preLoaderRoute: typeof MessagesIndexRouteImport
      parentRoute: typeof MessagesRouteRoute
    }
    '/wiki/new': {
      id: '/wiki/new'
      path: '/new'
      fullPath: '/wiki/new'
      preLoaderRoute: typeof WikiNewRouteImport
      parentRoute: typeof WikiRouteRoute
    }
    '/wiki/$slugWithTail': {
      id: '/wiki/$slugWithTail'
      path: '/$slugWithTail'
      fullPath: '/wiki/$slugWithTail'
      preLoaderRoute: typeof WikiSlugWithTailRouteImport
      parentRoute: typeof WikiRouteRoute
    }
    '/events/$eventId': {
      id: '/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof EventsEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/board/$projectId': {
      id: '/board/$projectId'
      path: '/board/$projectId'
      fullPath: '/board/$projectId'
      preLoaderRoute: typeof BoardProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/announcements/$announcementId': {
      id: '/announcements/$announcementId'
      path: '/announcements/$announcementId'
      fullPath: '/announcements/$announcementId'
      preLoaderRoute: typeof AnnouncementsAnnouncementIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messages/$conversationId': {
      id: '/messages/$conversationId'
      path: '/$conversationId'
      fullPath: '/messages/$conversationId'
      preLoaderRoute: typeof MessagesConversationIdRouteRouteImport
      parentRoute: typeof MessagesRouteRoute
    }
    '/messages/$conversationId/': {
      id: '/messages/$conversationId/'
      path: '/'
      fullPath: '/messages/$conversationId/'
      preLoaderRoute: typeof MessagesConversationIdIndexRouteImport
      parentRoute: typeof MessagesConversationIdRouteRoute
    }
    '/projects/$projectId/settings': {
      id: '/projects/$projectId/settings'
      path: '/projects/$projectId/settings'
      fullPath: '/projects/$projectId/settings'
      preLoaderRoute: typeof ProjectsProjectIdSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$projectCode/tickets/$shorthand': {
      id: '/$projectCode/tickets/$shorthand'
      path: '/$projectCode/tickets/$shorthand'
      fullPath: '/$projectCode/tickets/$shorthand'
      preLoaderRoute: typeof ProjectCodeTicketsShorthandRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$projectCode/tasks/$shorthand': {
      id: '/$projectCode/tasks/$shorthand'
      path: '/$projectCode/tasks/$shorthand'
      fullPath: '/$projectCode/tasks/$shorthand'
      preLoaderRoute: typeof ProjectCodeTasksShorthandRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wiki/d/$docId/': {
      id: '/wiki/d/$docId/'
      path: '/d/$docId'
      fullPath: '/wiki/d/$docId/'
      preLoaderRoute: typeof WikiDDocIdIndexRouteImport
      parentRoute: typeof WikiRouteRoute
    }
    '/messages/$conversationId/t/$parentId': {
      id: '/messages/$conversationId/t/$parentId'
      path: '/t/$parentId'
      fullPath: '/messages/$conversationId/t/$parentId'
      preLoaderRoute: typeof MessagesConversationIdTParentIdRouteImport
      parentRoute: typeof MessagesConversationIdRouteRoute
    }
    '/wiki/d/$docId/versions/': {
      id: '/wiki/d/$docId/versions/'
      path: '/d/$docId/versions'
      fullPath: '/wiki/d/$docId/versions/'
      preLoaderRoute: typeof WikiDDocIdVersionsIndexRouteImport
      parentRoute: typeof WikiRouteRoute
    }
  }
}

interface MessagesConversationIdRouteRouteChildren {
  MessagesConversationIdIndexRoute: typeof MessagesConversationIdIndexRoute
  MessagesConversationIdTParentIdRoute: typeof MessagesConversationIdTParentIdRoute
}

const MessagesConversationIdRouteRouteChildren: MessagesConversationIdRouteRouteChildren =
  {
    MessagesConversationIdIndexRoute: MessagesConversationIdIndexRoute,
    MessagesConversationIdTParentIdRoute: MessagesConversationIdTParentIdRoute,
  }

const MessagesConversationIdRouteRouteWithChildren =
  MessagesConversationIdRouteRoute._addFileChildren(
    MessagesConversationIdRouteRouteChildren,
  )

interface MessagesRouteRouteChildren {
  MessagesConversationIdRouteRoute: typeof MessagesConversationIdRouteRouteWithChildren
  MessagesIndexRoute: typeof MessagesIndexRoute
}

const MessagesRouteRouteChildren: MessagesRouteRouteChildren = {
  MessagesConversationIdRouteRoute:
    MessagesConversationIdRouteRouteWithChildren,
  MessagesIndexRoute: MessagesIndexRoute,
}

const MessagesRouteRouteWithChildren = MessagesRouteRoute._addFileChildren(
  MessagesRouteRouteChildren,
)

interface WikiRouteRouteChildren {
  WikiSlugWithTailRoute: typeof WikiSlugWithTailRoute
  WikiNewRoute: typeof WikiNewRoute
  WikiIndexRoute: typeof WikiIndexRoute
  WikiDDocIdIndexRoute: typeof WikiDDocIdIndexRoute
  WikiDDocIdVersionsIndexRoute: typeof WikiDDocIdVersionsIndexRoute
}

const WikiRouteRouteChildren: WikiRouteRouteChildren = {
  WikiSlugWithTailRoute: WikiSlugWithTailRoute,
  WikiNewRoute: WikiNewRoute,
  WikiIndexRoute: WikiIndexRoute,
  WikiDDocIdIndexRoute: WikiDDocIdIndexRoute,
  WikiDDocIdVersionsIndexRoute: WikiDDocIdVersionsIndexRoute,
}

const WikiRouteRouteWithChildren = WikiRouteRoute._addFileChildren(
  WikiRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  MessagesRouteRoute: MessagesRouteRouteWithChildren,
  WikiRouteRoute: WikiRouteRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  ApprovalsRoute: ApprovalsRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  ReportsRoute: ReportsRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  TimesheetRoute: TimesheetRoute,
  AnnouncementsAnnouncementIdRoute: AnnouncementsAnnouncementIdRoute,
  BoardProjectIdRoute: BoardProjectIdRoute,
  EventsEventIdRoute: EventsEventIdRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  ProjectCodeTasksShorthandRoute: ProjectCodeTasksShorthandRoute,
  ProjectCodeTicketsShorthandRoute: ProjectCodeTicketsShorthandRoute,
  ProjectsProjectIdSettingsRoute: ProjectsProjectIdSettingsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
